import { TimeClip } from "#packages/ecma262-abstract/TimeClip.js";
import { PartitionPattern } from "#packages/ecma402-abstract/PartitionPattern.js";
import "#packages/ecma402-abstract/types/date-time.js";
import { invariant } from "#packages/ecma402-abstract/utils.js";
import { FormatDateTimePattern } from "#packages/ecma402-abstract/DateTimeFormat/FormatDateTimePattern.js";
import "#packages/ecma402-abstract/DateTimeFormat/ToLocalTime.js";
/**
* https://tc39.es/ecma402/#sec-partitiondatetimepattern
* @param dtf
* @param x
*/
export function PartitionDateTimePattern(dtf, x, implDetails) {
	x = TimeClip(x);
	invariant(!x.isNaN(), "Invalid time", RangeError);
	/** IMPL START */
	const { getInternalSlots } = implDetails;
	const internalSlots = getInternalSlots(dtf);
	/** IMPL END */
	const { pattern } = internalSlots;
	return FormatDateTimePattern(dtf, PartitionPattern(pattern), x, implDetails);
}
